<div class="row fuelux" *ngIf="stage === 'idle'">
    <div class="col-lg-12">
        <div class="main-box clearfix">
            <div class="main-box-body clearfix wizardmainbox">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="main-box clearfix" style="min-height: 200px;">
                            <div class="row">
                                <div class="col-lg-5 col-lg-offset-1" style="margin-top: 2%; padding: 0 20px 20px 20px;">
                                    <div class="form-group">
                                        <label for="unifiedSourceType" class="control-label">
                                            Source Type <em> * </em> :
                                        </label>
                                        <select class="form-control" id="unifiedSourceType" name="unifiedSourceType"
                                            [(ngModel)]="sourceType" [disabled]="disableSourceTypesFlag">
                                            <option [ngValue]="undefined" disabled>Select</option>
                                            <option *ngFor="let source of sourceTypeList" [ngValue]="source">{{source.sourceType}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-lg-offset-1" style="margin-top: 2%; padding: 0px 26px 20px 20px;">
                                    <div>
                                        <label for="unifiedUploadDate" class="control-label">Upload Date <em> * </em> :</label>
                                        <div class="input-group">
                                            <span class="input-group-addon cursor-pointer" (click)="openDatePicker()">
                                                <i class="fa fa-calendar"></i>
                                            </span>
                                            <input type="text" class="form-control" placeholder="mm-dd-yyyy" id="unifiedUploadDate">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="main-box-body clearfix col-lg-10 col-lg-offset-1">
                                <div class="unified-dropzone" [ngClass]="{'unified-dropzone-hover': dragOver}">
                                    <i class="fa fa-cloud-upload-alt unified-dropzone-icon"></i>
                                    <div *ngIf="!dragOver">
                                        <h3>Drag and drop resumes or folders here</h3>
                                        <div class="unified-dropzone-or">or</div>
                                    </div>
                                    <h3 class="unified-dropzone-release" *ngIf="dragOver">Release to add</h3>
                                    <div class="unified-dropzone-actions">
                                        <button type="button" class="btn btn-primary" (click)="fileInput.click()">
                                            <i class="fa fa-file"></i> Choose files
                                        </button>
                                        <button type="button" class="btn btn-default unified-btn" (click)="folderInput.click()">
                                            <i class="fa fa-folder"></i> Choose folder
                                        </button>
                                    </div>
                                    <div class="unified-dropzone-hint">PDF, DOC, DOCX, XLSX &middot; folders are scanned including sub-folders</div>
                                </div>
                                <div class="unified-footer">
                                    <span class="unified-footer-note">Nothing selected yet</span>
                                    <button type="button" class="btn btn-primary" disabled>Upload</button>
                                </div>
                            </div>
                            <div class="row buttonrow" style="margin-bottom: 200px"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<input #fileInput type="file" class="hidden" multiple accept=".pdf,.xlsx,.docx,.doc"
    (change)="onFilesPicked(fileInput)">
<input #folderInput type="file" class="hidden" multiple webkitdirectory
    (change)="onFolderPicked(folderInput)">

<app-upload-resumes *ngIf="stage === 'files'"
    [jobId]="jobId"
    [candidateId]="candidateId"
    [initialSourceTypeId]="sourceType?.id"
    [initialUploadDate]="uploadDate"
    (cancelCallback)="cancelCallback.emit()"
    (candidateProcessedCallback)="onFilesProcessed()"
    (completeCallback)="completeCallback.emit()"
    [controlObject]="controlObject"
    [sourceScreen]="sourceScreen"
    [formalizeActivityPayload]="formalizeActivityPayload">
</app-upload-resumes>

<app-bulk-resume-upload *ngIf="stage === 'folders'"
    [jobId]="jobId"
    [sourceTypeList]="sourceTypeList"
    [disableSourceTypesFlag]="disableSourceTypesFlag"
    [initialSourceTypeId]="sourceType?.id"
    [initialUploadDate]="uploadDate"
    (selectionCleared)="onFoldersCleared()"
    (completeCallback)="completeCallback.emit()">
</app-bulk-resume-upload>
